module.exports = __webpack_public_path__ + "static/media/landing image.7ec580a6.png";